import React, {useState} from "react";
import styled from "styled-components";
import CarComponent from "../CarComponent/CarComponent";
import SingleCellDiv from '../SingleCellDiv';
import SingleRowDiv from '../SingleRowDiv';
import CarsReservedComponent from "../CarsViewComponent/CarsReservedComponent";
import moment from "moment";
import guild from "../../store/helpers/guid";
import CarRentalListDialog from "../CarRentalList/CarRentalListDialog";

const GridItem = styled.div`
    border: lightgrey solid;
    border-width: 0 0.2px 0.2px 0.2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const CarColumnGridItem = styled(GridItem)`
    grid-column-end: span 2;
    background-color: white;
    border-width: 0 0.2px 0.2px 0;
    position:sticky;
    left:0;
    background-color: white;
    z-index: 1;
    cursor: default;
    justify-content:space-evenly;
`;


const CarRowMultipleDaysView = (
    {
        car,
        daysCount,
        startDate,
        carPositions,
        endDate,
        getCorrectDateByType,
        onCarIdChangeHandler,
        onDialogOpenHandler,
        editRentHandler,
        onFetchRentHandler,
        gridContainedRef,
        cellWidth,
    }
) => {

    const [isCarRentalListDialogOpen, setIsCarRentalListDialogOpen] = useState(false);

    return (<React.Fragment>
        <CarColumnGridItem>
            <CarComponent
                car={car}
                onSelectedCarClick={() => setIsCarRentalListDialogOpen(true)}
            />
            {
                (
                    <CarRentalListDialog
                        isCarRentalListDialogOpen={isCarRentalListDialogOpen}
                        editRentHandler={editRentHandler}
                        car={car}
                        onCloseCarRentalListDialog={() => setIsCarRentalListDialogOpen(false)}
                    />
                )
            }
        </CarColumnGridItem>

        {
            Array.from({length: daysCount}).map((val, index) => {
                const cellDate = startDate.clone().add(index, "days").format("YYYY-MM-DD");
                const bookingsToday = car.lista_wynajmow.reduce(
                    (bookings, curVal) => {
                        if (moment.unix(curVal.data_od).format("YYYY-MM-DD") === cellDate) {
                            bookings.push(curVal);
                        } else if (moment.unix(curVal.data_od).format("YYYY-MM-DD") < cellDate
                            && index === 0) {
                            bookings.push(curVal);
                        }
                        return bookings;
                    }, []
                );
                return (
                    <SingleRowDiv
                        key={guild()}
                        type={2}
                        onClick={() => {
                            onCarIdChangeHandler(car.id);
                            onDialogOpenHandler(false, moment(cellDate).unix());
                        }}
                        cellDate={cellDate}
                    >
                        {" "}
                        {
                            bookingsToday.map(booking => {
                                const parsedStartDate = moment.unix(booking.data_od);
                                const periodEndDate = startDate.clone().add(daysCount - 1, "days").endOf("day");
                                const parsedEndDate = booking.data_do != 0 ? moment.unix(booking.data_do) : periodEndDate;
                                const startingPosition = parsedStartDate < startDate ? 0 : parsedStartDate.diff(parsedStartDate.clone().startOf("day"));
                                const bookingWidth = (parsedStartDate < startDate && parsedEndDate < periodEndDate)
                                    ? parsedEndDate.diff(parsedStartDate) - (startDate.diff(parsedStartDate))
                                    : parsedEndDate.diff(parsedStartDate);
                                const client = booking.klient;

                                return (
                                    <CarsReservedComponent
                                        key={guild()}
                                        ident={guild()}
                                        onDialogOpenHandler={onDialogOpenHandler}
                                        startDate={startDate}
                                        endDate={endDate}
                                        getCorrectDateByType={getCorrectDateByType}
                                        carId={car.id}
                                        carPositions={carPositions}
                                        onUpdateRentHandler={onFetchRentHandler}
                                        booking={booking}
                                        parentRef={gridContainedRef}
                                        daysCount={daysCount}
                                        index={index}
                                        startingPosition={startingPosition}
                                        cellWidth={cellWidth}
                                        bookingWidth={bookingWidth}
                                        periodStartDate={startDate}
                                        periodEndDate={periodEndDate}
                                    >
                                        {client}
                                    </CarsReservedComponent>
                                );
                            })
                        }
                    </SingleRowDiv>
                )
            })
        }
    </React.Fragment>);
};

export default CarRowMultipleDaysView
